const faqs = [
  {
    question: "How fast can I get a passport in Delaware?",
    answer:
      "With Fast Passport Center's registered courier service, Delaware residents can receive a passport in as little as 24–48 hours. Our standard expedited service ranges from 3 to 9 business days. Routine processing through the post office typically takes 6 to 13 weeks. Delaware's small size means all residents can access the same fast turnaround times, whether you are in Wilmington, Dover, or Rehoboth Beach.",
  },
  {
    question: "Does Delaware have a regional passport agency?",
    answer:
      "Delaware does not have a regional passport agency. The closest facilities are the Philadelphia Passport Agency (600 Arch St Suite 4200) and the Washington Passport Agency (600 19th St NW). Both require appointments and serve travelers with life-or-death emergencies or travel within 14 days. Fast Passport Center eliminates the need to travel to Philadelphia or DC by handling all courier delivery directly.",
  },
  {
    question: "Do I need to visit a passport acceptance facility in Delaware?",
    answer:
      "First-time applicants, minors under 16, and those replacing lost or stolen passports must visit an authorized acceptance facility (typically a post office or county clerk). Delaware has dozens of acceptance facilities across its three counties. Renewals for adults with a passport issued within the last 15 years can usually be done by mail without an in-person visit.",
  },
  {
    question: "Which airport should I fly from in Delaware?",
    answer:
      "New Castle Airport (ILG) near Wilmington offers domestic flights. For international travel, most Delaware residents use Philadelphia International Airport (PHL) — approximately 25 minutes from Wilmington. Baltimore-Washington International (BWI) is also a popular option for Sussex County residents.",
  },
  {
    question: "Can I renew my passport by mail in Delaware?",
    answer:
      "Yes — if your most recent passport was issued when you were 16 or older, was issued within the last 15 years, is undamaged, and was issued in your current name (or you have legal documentation of a name change), you can renew by mail using Form DS-82. Mail your application to the National Passport Processing Center. For faster service, use Fast Passport Center's approved expedited courier.",
  },
  {
    question: "Do I need a passport for a cruise from Philadelphia or Baltimore?",
    answer:
      "For closed-loop cruises (beginning and ending at the same U.S. port), U.S. citizens can sometimes travel with a government-issued photo ID and birth certificate. However, having a valid passport is strongly recommended — if an emergency requires you to fly home from a foreign port, you cannot board a flight without a passport. Many cruise lines now require passports regardless of the itinerary.",
  },
  {
    question: "How much does an expedited passport cost in Delaware?",
    answer:
      "Government passport fees are the same nationwide: $130 for a large passport book (adult) plus a $60 government expedite fee. Fast Passport Center's service fees vary by processing speed — emergency 24–48 hour processing, 2–9 business day expedited, or standard options. Contact us for a personalized quote based on your travel timeline.",
  },
  {
    question: "Can Fast Passport Center help with child passports in Delaware?",
    answer:
      "Yes. Fast Passport Center expedites child passports in Delaware for minors under 16. Both parents must appear with the child at an acceptance facility or submit notarized consent, along with the child's birth certificate and both parents' government-issued IDs. We help Delaware families navigate the entire process.",
  },
];

export { faqs };

export default function DelawareFAQSection() {
  return (
    <section id="faq" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-3xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">FAQ</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Delaware Passport Questions
          </h2>
          <p className="text-gray-500 text-base leading-relaxed">
            Quick answers for travelers applying for expedited and emergency passports across the First State.
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, i) => (
            <details
              key={i}
              className="group bg-white rounded-lg border border-gray-200 overflow-hidden"
            >
              <summary className="flex items-center justify-between cursor-pointer p-5 list-none">
                <span className="font-bold text-[#1A365D] text-sm pr-4">{faq.question}</span>
                <div className="w-7 h-7 flex items-center justify-center rounded-full bg-[#EEF2F8] flex-shrink-0">
                  <i className="ri-add-line text-[#1A365D] text-sm group-open:ri-subtract-line"></i>
                </div>
              </summary>
              <div className="px-5 pb-5">
                <p className="text-gray-500 text-sm leading-relaxed">{faq.answer}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}